export type AccountPathway = 'msme' | 'enterprise';

export const ACCOUNT_PATHWAY_STORAGE_KEY = 'carbonAccountPathway';

export const ACCOUNT_PATHWAY_LABELS: Record<AccountPathway, string> = {
  msme: 'MSME carbon emissions',
  enterprise: 'Large companies / enterprise carbon emissions',
};

export const isAccountPathway = (value: string | null | undefined): value is AccountPathway =>
  value === 'msme' || value === 'enterprise';

export const getStoredAccountPathway = (): AccountPathway | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    const raw = localStorage.getItem(ACCOUNT_PATHWAY_STORAGE_KEY);
    return isAccountPathway(raw) ? raw : null;
  } catch {
    return null;
  }
};

export const setStoredAccountPathway = (pathway: AccountPathway) => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    localStorage.setItem(ACCOUNT_PATHWAY_STORAGE_KEY, pathway);
  } catch {
    /* ignore */
  }
};

export const clearStoredAccountPathway = () => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    localStorage.removeItem(ACCOUNT_PATHWAY_STORAGE_KEY);
  } catch {
    /* ignore */
  }
};
